import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../shared/auth.guard';
import { UserTypes } from '../shared/interfaces';
import { SharedModule } from '../shared/shared.module';
import { SettingFormComponent } from './setting-form/setting-form.component';
import { SettingListComponent } from './setting-list/setting-list.component';
import { SettingResolver } from './setting.resolver';

const routes: Routes = [
  {
    path: '',
    data: { title: 'Settings' },
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        canActivate: [AuthGuard],
        component: SettingListComponent,
        data: { title: 'All Settings', userTypes: [UserTypes.ADMIN] },
      },
      {
        path: 'form/:id',
        canActivate: [AuthGuard],
        component: SettingFormComponent,
        resolve: { setting: SettingResolver },
        data: { title: 'Details', userTypes: [UserTypes.ADMIN] },
      },
    ],
  },
];

@NgModule({
  imports: [SharedModule, RouterModule.forChild(routes)],
  declarations: [SettingListComponent, SettingFormComponent],
  exports: [RouterModule],
})
export class SettingModule {}
